export const isDevelop = import.meta.env.__DEV__;

type FeatureFlag = {
  canUse: boolean;
  redirect: string;
};

export const MEDICAL_DEVICES_FEATURE: FeatureFlag = {
  canUse: isDevelop || import.meta.env.__SHOW_MEDICAL_DEVICES_FEATURE__,
  redirect: '/not_found',
};
